import { getBeginningValidity, getEndValidity } from '../utils/functions';
import { roles } from '../utils/constants';
import { decryptCredentials } from '../utils/cifrate';

const getDescDoc = (doc) => {
  const docDesc = {
    2: 'DNI',
    4: 'CE',
  };
  return docDesc[doc];
};

export const getParentesco = (ind, type) => {
  const parentesco = {
    0: 'TITULAR',
    1: type ? 'CONYUGE' : 'CÓNYUGE',
    4: type ? 'HIJO' : 'HIJO/A',
  };
  return parentesco[ind];
};

const getGender = (ind) => {
  const genders = {
    F: 'FEMENINO',
    M: 'MASCULINO',
  };
  return genders[ind];
};

/* const getIndDoc = (doc) => {
  const docDesc = {
    DNI: 2,
    'C.E': 4,
  };
  return docDesc[doc];
}; */

const getContractor = (thirdData) => {
  const {
    client,
    address,
  } = thirdData;
  const contratante = {
    ideRol: roles.contratante,
    tipoDocumento: client.tipoDocumento.toString(),
    numeroDocumento: client.numeroDocumento || client.numDoc,
    nombre: client?.nombres || '',
    apePaterno: client?.apellidoPaterno || '',
    apeMaterno: client?.apellidoMaterno || '',
    correo: client?.correo || '',
    telefono: client?.telefono || '',
    estCivil: 'S',
    fecNacimiento: client?.fechaNacimiento || '',
    sexo: client.sexo || client.gender,
  };
  if (address.address) {
    contratante.direccion = address.address;
    contratante.codDepartamento = address.departament.id;
    contratante.codProvincia = address.province.id;
    contratante.codDistrito = address.district.id;
    contratante.pais = 'PERU';
    contratante.departamento = address.departament.desc;
    contratante.provincia = address.province.desc;
    contratante.distrito = address.district.desc;
    contratante.codPais = address.idPais;
  }

  contratante.indExisteTercero = true;
  return contratante;
};

// Old request salud flexible
// export const requestValidation = (insureds) => ({
//   tipoFlujo: decryptCredentials(process.env.REACT_APP_TIPO_FLUJO),
//   ideCanal: decryptCredentials(process.env.REACT_APP_ID_CANAL),
//   ideVendedor: decryptCredentials(process.env.REACT_APP_ID_VENDEDOR),
//   ideGrupoProd: decryptCredentials(process.env.REACT_APP_ID_GRUPO_PRODUCTO),
//   usuEmision: decryptCredentials(process.env.REACT_APP_USUARIO_EMISION),
//   idpMoneda: decryptCredentials(process.env.REACT_APP_CODIGO_SOLES),
//   fecIniVig: getBeginningValidity(),
//   fecFinVig: getEndValidity(),
//   periodo: decryptCredentials(process.env.REACT_APP_PERIODO),
//   numIdIntermediario: decryptCredentials(process.env.REACT_APP_NUM_ID_INTERMEDIARIO),
//   usuarioEmisor: decryptCredentials(process.env.REACT_APP_USUARIO_EMISOR),
//   canal: decryptCredentials(process.env.REACT_APP_CANAL),
//   asegurados: insureds,
//   indicadorCotizacion: decryptCredentials(process.env.REACT_APP_INDICADOR_COTIZACION),
//   indConsentimiento: decryptCredentials(process.env.REACT_APP_INDICADOR_CONSENTIMIENTO),
//   financiamiento: {
//     idePlanFinanciamiento: decryptCredentials(process.env.REACT_APP_ID_PLAN_FINANCIAMIENTO_SOLES),
//     numCuota: decryptCredentials(process.env.REACT_APP_NUMERO_CUOTAS),
//     fecIni: getBeginningValidity(),
//     ideTipoTarjetaRefExt: '',
//   },
//   cotizacionRapida: 0,
// });

export const requestValidation = (insureds, plansId) => ({
  tipoFlujo: decryptCredentials(process.env.REACT_APP_TIPO_FLUJO),
  ideCanal: Number(decryptCredentials(process.env.REACT_APP_ID_CANAL)),
  ideVendedor: Number(decryptCredentials(process.env.REACT_APP_ID_VENDEDOR)),
  ideGrupoProd: Number(decryptCredentials(process.env.REACT_APP_ID_GRUPO_PRODUCTO)), // here
  usuEmision: decryptCredentials(process.env.REACT_APP_USUARIO_EMISION),
  idpMoneda: decryptCredentials(process.env.REACT_APP_CODIGO_SOLES),
  fecIniVig: getBeginningValidity(),
  fecFinVig: getEndValidity(),
  periodo: Number(decryptCredentials(process.env.REACT_APP_PERIODO)),
  numIdIntermediario: Number(decryptCredentials(process.env.REACT_APP_NUM_ID_INTERMEDIARIO)),
  usuarioEmisor: decryptCredentials(process.env.REACT_APP_USUARIO_EMISOR),
  canal: decryptCredentials(process.env.REACT_APP_CANAL),
  asegurados: insureds,
  indicadorCotizacion: decryptCredentials(process.env.REACT_APP_INDICADOR_COTIZACION),
  indConsentimiento: decryptCredentials(process.env.REACT_APP_INDICADOR_CONSENTIMIENTO),
  financiamiento: {
    idePlanFinanciamiento: parseInt(decryptCredentials(process.env.REACT_APP_ID_PLAN_FINANCIAMIENTO_SOLES), 10),
    numCuota: Number(decryptCredentials(process.env.REACT_APP_NUMERO_CUOTAS)),
    fecIni: getBeginningValidity(),
    ideTipoTarjetaRefExt: '',
  },
  cotizacionRapida: 0,
  idePlanSinReferencia: false,
  idePlanes: plansId,
});

export const requestQuote = (insured, lastStep, idPlan) => {
  const request = {
    tipoFlujo: decryptCredentials(process.env.REACT_APP_TIPO_FLUJO),
    ideCanal: parseInt(decryptCredentials(process.env.REACT_APP_ID_CANAL), 10),
    ideVendedor: parseInt(decryptCredentials(process.env.REACT_APP_ID_VENDEDOR), 10),
    ideGrupoProd: parseInt(decryptCredentials(process.env.REACT_APP_ID_GRUPO_PRODUCTO), 10),
    usuEmision: decryptCredentials(process.env.REACT_APP_USUARIO_EMISION),
    idpMoneda: decryptCredentials(process.env.REACT_APP_CODIGO_SOLES),
    fecIniVig: getBeginningValidity(),
    fecFinVig: getEndValidity(),
    periodo: parseInt(decryptCredentials(process.env.REACT_APP_PERIODO), 10),
    numIdIntermediario:
      parseInt(decryptCredentials(process.env.REACT_APP_NUM_ID_INTERMEDIARIO), 10),
    usuarioEmisor: decryptCredentials(process.env.REACT_APP_USUARIO_EMISOR),
    canal: decryptCredentials(process.env.REACT_APP_CANAL),
    asegurados: insured,
    indicadorCotizacion: decryptCredentials(process.env.REACT_APP_INDICADOR_COTIZACION),
    indConsentimiento: decryptCredentials(process.env.REACT_APP_INDICADOR_CONSENTIMIENTO),
    financiamiento: {
      idePlanFinanciamiento:
        parseInt(decryptCredentials(process.env.REACT_APP_ID_PLAN_FINANCIAMIENTO_SOLES), 10),
      numCuota: parseInt(decryptCredentials(process.env.REACT_APP_NUMERO_CUOTAS), 10),
      fecIni: getBeginningValidity(),
      ideTipoTarjetaRefExt: '',
    },
    cotizacionRapida: 0,
  };
  if (lastStep) {
    request.clienteAplicacion = '841a7f06-9427-4b8f-9cfa-eddc2f957b8a';
    request.tipFacturacion = 'IRR';
    request.agenciamiento = '002';
    request.idePlan = idPlan;
  }
  return request;
};

export const requestQuoteData = (state, lastStep) => {
  const {
    idQuote,
    address,
    insuredList,
    dps,
    planFlexSelected,
  } = state;
  const aseguradoTitular = insuredList.find((e) => e.relationship === 0);
  const insureds = insuredList.map((insured, i) => {
    let asegurado = {};
    asegurado = {
      tipDocumento: String(insured.typeDoc),
      numDocumento: insured.numDocument || insured.numDoc,
      fecNacimiento: insured.born,
      parentesco: insured.relationship,
      sexo: insured.idGender || insured.gender,
      edad: insured.age,
      peso: Number(dps.insured[i].peso),
      talla: Number(dps.insured[i].talla),
      nombre: insured.name,
      apePaterno: insured.lastname1,
      apeMaterno: insured.lastname2,
      estCivil: 'S',
      direccion: address.address,
      telefono: insured.phone ? insured.phone : aseguradoTitular.telefono,
      codDepartamento: address.departament.id,
      codProvincia: address.province.id,
      codDistrito: address.district.id,
      mail: insured.email ? insured.email : aseguradoTitular.mail,
      pais: 'PERU',
      departamento: address.departament.desc,
      provincia: address.province.desc,
      distrito: address.district.desc,
      codPais: address.idPais,
    };
    return asegurado;
  });

  const payloadCotizacion = requestQuote(insureds, lastStep, planFlexSelected?.idePlanOriginal);
  payloadCotizacion.ideCotizacion = idQuote;

  return payloadCotizacion;
};

export const requestSelectPlan = (data) => {
  const { idQuote, planFlexSelected, secondPlanFlexSelected } = data;
  let idePlan = [planFlexSelected?.idePlan];
  if (secondPlanFlexSelected) {
    idePlan = [planFlexSelected?.idePlan, secondPlanFlexSelected?.idePlan];
  }
  return {
    ideCotizacion: idQuote,
    idePlan,
    usuModif: decryptCredentials(process.env.REACT_APP_USUARIO_EMISION),
  };
};

export const requestThird = (thirdInfo, lastStep) => {
  const {
    idQuote,
  } = thirdInfo;

  const contratante = getContractor(thirdInfo);
  if (lastStep) {
    delete contratante.indExisteTercero;
  }
  const respPago = JSON.parse(JSON.stringify(contratante));
  respPago.ideRol = roles.responsablePago;
  const reqResult = {
    ideCotizacion: idQuote.toString(),
    terceros: [contratante, respPago],
    cotizacionRapida: lastStep ? 0 : 1,
  };
  return reqResult;
};

export const requestSession = (idQuote) => {
  const request = { ideCotizacion: idQuote };
  return request;
};

export const requestDps = (data) => {
  const {
    idQuote,
    insuredList,
    address,
    dps,
    client,
    nroCuotas = 12,
  } = data;

  let arrayAsegurados = [];

  const contratante = {
    tipoDocumento: getDescDoc(client.tipoDocumento),
    numeroDocumento: client.numeroDocumento || client.numDoc,
    nombres: `${(client.nombres.split(' ')[0]).toUpperCase()} ${client.apellidoPaterno} ${client.apellidoMaterno}`,
    fechaNacimiento: client.fechaNacimiento,
    sexo: getGender(client.sexo),
    estadoCivil: 'Soltero',
    telefono: '',
    celular: client.telefono,
    correo: client.correo,
    direccion: address?.address,
    distrito: address?.district?.desc,
    provincia: address?.province?.desc,
    departamento: address?.departament?.desc,
  };

  if (insuredList) {
    arrayAsegurados = insuredList.map((asegurado, i) => ({
      nombres: `${(asegurado.name).toUpperCase()} ${asegurado.lastname1} ${asegurado.lastname2}`,
      tipoDocumento: getDescDoc(asegurado.typeDoc),
      numeroDocumento: asegurado.numDoc,
      fechaNacimiento: asegurado.born,
      sexo: getGender(asegurado.gender),
      estadoCivil: 'Soltero',
      estatura: String(dps?.insured?.[i]?.talla),
      peso: String(dps?.insured?.[i]?.peso),
      telefono: '',
      celular: asegurado.phone,
      correo: asegurado.email,
      direccion: address?.address,
      parentesco: getParentesco(asegurado.relationship),
      distrito: address?.district?.desc,
      provincia: address?.province?.desc,
      departamento: address?.departament?.desc,
    }));
  }
  const fDps = dps.answers.map((answer, i) => ({ idPregunta: `P0${i + 1}`, respuesta: answer }));
  return {
    resumenDPS: {
      ideCotizacion: idQuote,
      producto: '3844',
      contratante,
      asegurados: arrayAsegurados,
      respuestas: fDps,
      pago: {
        metodo: 'Cargo automático',
        cuotas: String(nroCuotas),
        tea: '0',
      },
    },
  };
};

export const requestSusDps = (state) => {
  const { idQuote } = state;
  const fDps = [1, 2, 3, 4].map((i) => ({ pregunta: i, respuesta: 'S' }));
  return {
    ideCotizacion: idQuote,
    suscripcion: fDps,
  };
};

export const requestUploadDps = (state) => {
  const { idQuote } = state;
  const product = state.planFlexSelected?.dscProducto || '';
  const plan = state.planFlexSelected?.nroPlan || '';

  return {
    generarPDS: {
      ideCotizacion: idQuote,
      producto: '3844',
      productName: product !== '' ? `${product} - ${plan}` : '',
    },
  };
};

export const requestAddRouteDps = (state, payload) => {
  const { idQuote } = state;
  const req = {
    ideCotizacion: idQuote,
    ruta: payload?.payload.url,
  };
  return req;
};

export const requestCalculatePlan = (idQuote, singleQuote = true) => {
  const payloadDescuento = {
    tipoFlujo: 'SAL-FLE',
    planes: [
      {
        cotizacion: idQuote,
        cotizacionRapida: singleQuote ? 1 : 0,
        nroCuota: 12,
      },
    ],
  };
  return payloadDescuento;
};
